import React from 'react';
import { LdpmMetricKey } from '../types/StockData';

interface LdpmMetricSelectorProps {
  selectedMetric: LdpmMetricKey;
  onMetricChange: (metric: LdpmMetricKey) => void;
}

const LdpmMetricSelector: React.FC<LdpmMetricSelectorProps> = ({
  selectedMetric,
  onMetricChange
}) => {
  const metricOptions: { value: LdpmMetricKey; label: string; description: string }[] = [
    { 
      value: 'ldpm', 
      label: 'LDPM', 
      description: 'Liquidity Driven Price Movement' 
    },
    { 
      value: 'volume', 
      label: 'Volume', 
      description: 'Trading volume' 
    },
    { 
      value: 'distanceFromPrice', 
      label: 'Distance from Price', 
      description: 'Distance between LDPM and current price' 
    },
    { 
      value: 'exponentialMultiplier', 
      label: 'Exponential Multiplier', 
      description: 'Exponential multiplier factor' 
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Secondary Metric</h3>
      <p className="text-sm text-gray-600 mb-4">
        Choose an additional metric to display alongside LDPM and price data
      </p>
      
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {metricOptions.map((option) => (
          <button
            key={option.value}
            onClick={() => onMetricChange(option.value)}
            className={`p-3 text-left rounded-lg border-2 transition-all hover:shadow-md ${
              selectedMetric === option.value
                ? 'border-purple-500 bg-purple-50 text-purple-900'
                : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300'
            }`}
            title={option.description}
          >
            <div className="font-medium text-sm">{option.label}</div>
            <div className="text-xs text-gray-500 mt-1 line-clamp-2">
              {option.description}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LdpmMetricSelector;
